import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, H2, Reviews } from '../../components';
import ReviewsContainer from '../../components/ReviewsContainer/ReviewsContainer';

import css from './ListingPage.module.css';

const SectionReviews = props => {
  const {
    reviews,
    fetchReviewsError,
    publicData,
  } = props;

  if (reviews.length === 0) return null;

  return (
    <div className={css.sectionReviewsCard}>
      <div className={css.sectionReviewsHeader}>
        <Heading as="h2" rootClassName={css.sectionHeadingNoMargin}>
          <FormattedMessage id="ListingPage.reviewsTitle" values={{ count: reviews.length }} />
        </Heading>
        <ReviewsContainer publicData={publicData} reviews={reviews} />
      </div>

      {fetchReviewsError ? (
        <H2 className={css.errorText}>
          <FormattedMessage id="ListingPage.reviewsError" />
        </H2>
      ) : null}
      <Reviews reviews={reviews} />
    </div>
  );
};

export default SectionReviews;
